export default __webpack_public_path__ + "alberta-fab-remove-duplicate.7c5257d6818c6a532417.svg";